"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9805],{

/***/ 59805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18132);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27120);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37930);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58598);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);











var Offer = function Offer(_ref) {
  var item = _ref.item;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  var title = "".concat(item.brand, " ").concat(item.model);
  var altTitle = "Noleggio a Lungo Termine ".concat(item.brand, " ").concat(item.model);
  var subtitle = item.version;
  var imageSrc = item.image;
  var href = ['/noleggio-a-lungo-termine/', item.brandCode, '/', item.modelCode, '/', item.code, '?deposit=', item.deposit, '&contractLength=', item.contractLength, '&annualMileage=', item.annualMileage].join('');
  var durationTitle = t('nltOffersComponent:durationTitle');
  var durationValue = t('nltOffersComponent:durationValue', {
    value: item.contractLength
  });
  var distanceTitle = t('nltOffersComponent:distanceTitle');
  var distanceValue = t('nltOffersComponent:distanceValue', {
    value: item.annualMileage == 0 ? 'illimitati' : item.annualMileage.toLocaleString('it-IT')
  });
  var depositTitle = t('nltOffersComponent:depositTitle');
  var depositValue = item.deposit === 0 ? t('nltOffersComponent:depositValue0', {
    value: item.deposit
  }) : t('nltOffersComponent:depositValue', {
    value: item.deposit.toLocaleString('it-IT')
  });
  var priceDescription = t('nltOffersComponent:priceDescription');
  var priceValue = t('nltOffersComponent:priceValue', {
    value: item.monthlyRate.toLocaleString('it-IT')
  });
  var limitedOfferBadge = null;

  if (item.expirationDate) {
    var offerTimeStamp = Date.parse(item.expirationDate);
    var nowTimeStamp = new Date().getTime();
    var diffTimeStamp = offerTimeStamp - nowTimeStamp;

    if (diffTimeStamp > 0) {
      limitedOfferBadge = t('nltOffersComponent:limitedOfferBadge', {
        value: Math.floor(diffTimeStamp / (24 * 60 * 60 * 1000))
      });
    }
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
    title: altTitle,
    borderRadius: 10,
    bg: "baseWhite",
    pb: "l",
    overflow: "hidden",
    pos: "relative",
    borderColor: src_themes__WEBPACK_IMPORTED_MODULE_4__/* .theme.colors.borders.grey */ .r.colors.borders.grey,
    borderWidth: 1,
    boxShadow: src_themes__WEBPACK_IMPORTED_MODULE_4__/* .theme.shadows.cards */ .r.shadows.cards,
    _hover: {
      cursor: 'pointer',
      textDecoration: 'none',
      boxShadow: '0 4px 12px 0px rgba(65, 164, 118, 0.22)'
    },
    onClick: function onClick() {
      return router.push(href);
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
      h: "12.5rem",
      mb: "xs",
      pos: "relative",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: imageSrc,
        alt: altTitle,
        layout: "fill",
        objectFit: "contain",
        loading: "lazy"
      }), limitedOfferBadge && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_5__/* .LimitedOfferBadge */ .Ld, {
        position: "absolute",
        top: "1rem",
        left: "1rem",
        children: limitedOfferBadge
      }), item.mainTag && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_5__/* .InfoBadge */ .Uq, {
        position: "absolute",
        bottom: ".625rem",
        left: "1rem",
        children: item.mainTag
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Divider */ .iz, {
        position: "absolute",
        bottom: "0rem"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Stack */ .Kq, {
      textAlign: "left",
      h: "8.5rem",
      pos: "relative",
      px: "m",
      position: "static",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
        href: href,
        style: {
          color: src_themes__WEBPACK_IMPORTED_MODULE_4__/* .theme.colors.baseDark */ .r.colors.baseDark
        },
        title: altTitle,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_5__/* .OfferCardTitle */ .PP, {
          title: title,
          subtitle: subtitle
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
        marginLeft: "l",
        position: "static",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_5__/* .PriceBox */ .bz, {
          value: priceValue,
          description: priceDescription,
          textAlign: "right",
          position: "absolute",
          top: "16.2rem",
          right: "1rem"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_5__/* .BadgeWithIcon */ .eF, {
          icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(src_icons__WEBPACK_IMPORTED_MODULE_3__/* .CarIcon */ .yx, {}),
          name: distanceTitle,
          value: distanceValue
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_5__/* .BadgeWithIcon */ .eF, {
          icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(src_icons__WEBPACK_IMPORTED_MODULE_3__/* .CalendarIcon */ .Qu, {}),
          name: durationTitle,
          value: durationValue
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_5__/* .BadgeWithIcon */ .eF, {
          icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(src_icons__WEBPACK_IMPORTED_MODULE_3__/* .CarIcon */ .yx, {}),
          name: depositTitle,
          value: depositValue
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Text */ .xv, {
          color: "baseDark",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "0.75rem",
          letterSpacing: "0.4px",
          marginTop: "xs",
          h: "16px",
          children: item.variations > 0 ? t('nltOffersComponent:variations', {
            count: item.variations
          }) : null
        })]
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Offer);

/***/ })

}]);